<template>
  <el-row>
    <el-col :span="8">
      <el-select v-model="provinceValue" placeholder="请选择" value-key="value" @change="selectProvimce(provinceValue.label)">
        <el-option
          v-for="(item,index) of province"
          :key="index"
          :label="item.label"
          :value="item"
        ></el-option>
      </el-select>
    </el-col>
    <el-col :span="8" style="padding-left:10px;">
      <el-select v-model="cityValue" placeholder="请选择" value-key="value"  @change="selectcity(cityValue.label)">
        <el-option
          v-for="(item,index) of cityarr"
          :key="index"
          :label="item.label"
          :value="item"
        ></el-option>
      </el-select>
    </el-col>
    <el-col :span="8" style="padding-left:10px;">
      <el-select placeholder="请选择" v-model="regionValue" value-key="value"  @change="onRegionValue(regionValue.label)">
        <el-option
          v-for="(item,index) of regionarr"
          :key="index"
          :label="item.label"
          :value="item"
        ></el-option>
      </el-select>
    </el-col>
  </el-row>
</template>
<script>
import { citys } from '@/assets/js/citys.js'
export default {
  props: ['provinceEdit', 'city', 'district'],
  created() {
    this.province = citys
  },
  data() {
    return {
      province: [],
      cityarr: [],
      regionarr: [],
      provinceValue: {},
      cityValue: {},
      regionValue: {},
      addressParams: {}
    }
  },
  watch: {
    provinceEdit: {
      async handler(newVal) {
        if (newVal) {
          await this.selectProvimce(newVal.name)
          this.provinceValue = {
            value: newVal.id,
            label: newVal.name
          }
        } else {
          this.provinceValue = null
        }
      },
      deep: true
    },
    city: {
      async handler(newVal) {
        if (newVal) {
          this.cityValue = {
            value: newVal.id,
            label: newVal.name
          }
          await this.selectcity(newVal.name)
        } else {
          this.cityValue = null
        }
      },
      deep: true
    },
    district: {
      handler(newVal) {
        this.regionValue = {
          value: newVal.id,
          label: newVal.name
        }
      },
      deep: true
    }
  },
  mounted() {
    // 由于发起备货详情,页面初始打开弹窗时,获取不到省市区县,所以加一个mounted,如果有办法,可以改一下
    this.init()
  },
  methods: {
    init() {
      if (this.provinceEdit && this.city && this.provinceEdit.name && this.city.name) {
        this.selectProvimce(this.provinceEdit.name)
        this.selectcity(this.city.name)
        this.onRegionValue(this.district.name)
      }
    },
    // 省
    selectProvimce(id) {
      const obj = this.province.find((m) => m.label === id)
      this.provinceValue = obj
      this.cityarr = obj.children || []
      this.regionarr = []
      this.cityValue = {}
      this.regionValue = {}
    },
    // 市
    selectcity(id) {
      const obj = this.cityarr.find((m) => m.label === id)
      this.cityValue = obj
      this.regionarr = obj.children || []
      this.regionValue = {}
    },
    // 县
    onRegionValue(id) {
      this.regionValue = this.regionarr.find((m) => m.label === id)
      const nameParams =
        this.provinceValue.label +
        '-' +
        this.cityValue.label +
        '-' +
        this.regionValue.label
      const codeParams =
        this.provinceValue.value +
        '-' +
        this.cityValue.value +
        '-' +
        this.regionValue.value
      this.addressParams.name = nameParams
      this.addressParams.code = codeParams
      this.$emit('changAddress', this.addressParams)
    }
  }
}
</script>
